/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerCrossJoinComponent', [
    '$timeout',
    'DesignerComponent',
    'DesignerSchema',

    function ($timeout, DesignerComponent, DesignerSchema) {
      function DesignerCrossJoinComponent() {
        DesignerComponent.apply(this);
      }

      DesignerCrossJoinComponent.prototype = new DesignerComponent();

      DesignerCrossJoinComponent.prototype.getSchema = function () {
        const SEPARATOR = '::';
        const schema = new DesignerSchema();

        schema.id = this.id;
        schema.name = this.name;

        if (this.inputEdges.length >= 2) {
          const firstSchema = this.inputEdges[0].sourceComponent.getSchema();
          const secondSchema = this.inputEdges[1].sourceComponent.getSchema();

          const intersection = _.intersection(_.map(firstSchema.fields, 'name'), _.map(secondSchema.fields, 'name'));

          if (intersection.length) {
            _.each(intersection, function (fieldName) {
              _.find(firstSchema.fields, { name: fieldName }).name = firstSchema.name + SEPARATOR + fieldName;
              _.find(secondSchema.fields, { name: fieldName }).name = secondSchema.name + SEPARATOR + fieldName;
            });
          }

          schema.fields = _(schema.fields).concat(firstSchema.fields).concat(secondSchema.fields).value();
        }

        return schema;
      };

      return DesignerCrossJoinComponent;
    },
  ]);
})(window.angular);
